import { Log, LogCategory, Operation } from '@augloop/logging';
import { ExecutionState, ContextIdManager } from '@augloop/mastermind-shared';
export class WorkflowExecutionTracker {
    constructor(node, onContextIdWorkflowExecutionComplete, oldTracker) {
        this.itemsContextId = new Set();
        this.executionState = new Map();
        this.graphNode = node;
        this.onContextIdWorkflowExecutionComplete = onContextIdWorkflowExecutionComplete;
        if (oldTracker) {
            this.itemsContextId = oldTracker.itemsContextId;
            this.executionState = oldTracker.executionState;
        }
    }
    addInputItemToProcess(contextId) {
        this.itemsContextId.add(contextId);
    }
    removeProcessedInputItem(contextId) {
        this.itemsContextId.delete(contextId);
    }
    countItemsToProcess(scopeContextId) {
        let count = 0;
        for (const contextId of this.itemsContextId) {
            if (contextId.indexOf(scopeContextId) === 0) {
                count += 1;
            }
        }
        return count;
    }
    getExecutionState() {
        return this.executionState;
    }
    setExecutionState(contextId, state) {
        if (!this.graphNode.isActivated) {
            Log.info(0x1e54f1d7 /* tag_4vphx */, LogCategory.CoreDefault, new Operation({ operationName: 'WorkflowExecutionTracker', resourceId: this.graphNode.workflow.id, joinContextId: contextId, resultDescription: `Trying to set state ${state} for a not activated workflow` }));
            return false;
        }
        if (!contextId) {
            Log.info(0x1f01e3ca /* tag_5a4pk */, LogCategory.CoreDefault, new Operation({ operationName: 'WorkflowExecutionTracker', resourceId: this.graphNode.workflow.id, joinContextId: contextId, resultDescription: `Trying to set state ${state} for a undefined contextId (setExecutionState)` }));
            return false;
        }
        this.executionState.set(contextId, state);
        return true;
    }
    beforeWorkflowExecution(contextId) {
        this.setExecutionState(contextId, ExecutionState.Pending);
    }
    afterWorkflowExecution(contextId) {
        if (this.setExecutionState(contextId, ExecutionState.Executed)) {
            this.tryToCompleteWorkflowExecution(contextId);
        }
    }
    clearWorkflowExecutions() {
        this.executionState.forEach((_state, contextId) => this.afterWorkflowExecution(contextId));
    }
    tryToCompleteWorkflowExecution(contextId) {
        const currentState = this.executionState.get(contextId);
        if (currentState !== ExecutionState.Executed) {
            return;
        }
        /**
         * Deleting the state associate with a ContextID is synonymous to Updating the state to Complete the execution on the Tracker.
         * We also try to complete the state of each contextId in all downstreamWorkflowNodes that can be reached from the current ExecutionTracker.
         */
        if (this.canCompleteExecution(contextId)) {
            this.executionState.delete(contextId);
            if (this.onContextIdWorkflowExecutionComplete) {
                this.onContextIdWorkflowExecutionComplete(this.graphNode.workflow.id, contextId);
            }
            for (const downstreamExecutionTracker of this.downstreamWorkflowExecutionTrackers) {
                for (const [dContextId, dState] of downstreamExecutionTracker.getExecutionState()) {
                    if (dState === ExecutionState.Executed && ContextIdManager.isParentContextId(contextId, dContextId) /** contextId is parent of dContextId */) {
                        downstreamExecutionTracker.tryToCompleteWorkflowExecution(dContextId);
                    }
                }
            }
        }
    }
    canCompleteExecution(contextId) {
        /**
         * A workflow execution can be considered 'Complete' when there is no pending execution state (Pending/Executed) for all upstream workflows
         * and for all states that has a parent contextId of the current contextId. We don't need check all upstream, but only the upstream neighboors
         * because they can not complete if there is still a parent upstream executing.
         */
        for (const upstreamWorkflowTracker of this.upstreamWorkflowExecutionTrackers) {
            for (const pContextId of upstreamWorkflowTracker.getExecutionState().keys()) {
                if (!ContextIdManager.isParentContextId(pContextId, contextId) /** pContextId is parent of contextId */) {
                    continue;
                }
                return false;
            }
        }
        return true;
    }
}
//# sourceMappingURL=local-workflow-execution-tracker.js.map